// components/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { checkAuth } from '@/store/slices/authSlice'; // 示例：验证函数

const ProtectedRoute = ({ 
  children, 
  requiredRoles = [],
  unauthorizedComponent 
}) => {
  const location = useLocation();
  const dispatch = useDispatch();
  
  // 从Redux状态获取用户信息
  const { isAuthenticated, user, loading } = useSelector(state => state.auth);
  
  
  // 组件挂载时检查认证状态
  useEffect(() => {
    if (!isAuthenticated) {
      // dispatch(checkAuth());
    }
  }, [dispatch, isAuthenticated]);
  
  // 显示加载状态
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="权限验证中..." />
      </div>
    );
  }
  
  const token = localStorage.getItem('access_token');
  const isUserAuthenticated = token || isAuthenticated;
  // 如果未认证，重定向到登录页
  if (!isUserAuthenticated) {
    return <Navigate to="/login/wechat" state={{ from: location }} replace />;
  }
  
  // 如果需要特定角色，检查权限
  if (requiredRoles.length > 0) {
    const userRole = user?.role || 'guest';
    const hasPermission = requiredRoles.includes(userRole);
    
    if (!hasPermission) {
      // 返回自定义的无权限组件或重定向
      if (unauthorizedComponent) {
        return unauthorizedComponent;
      }
      // 默认重定向到404或无权限页面
      return <Navigate to="/404" replace />;
    }
  }
  
  // 如果子组件是具体的React元素，直接渲染
  if (children) {
    return children;
  }
  
  // 否则渲染嵌套路由（使用Outlet）
  return <Outlet />;
};

export default ProtectedRoute;